import { domainUrl } from '../constants';

export const API_GET_ROLES = `${domainUrl}auth/roles`;
